// extracted by mini-css-extract-plugin
module.exports = {"pcSection":"MyPageMile_pcSection__ci7xn"};